import { currentStore } from "../../store/useStore";
import { DataRequestBuilder } from "@radixdlt/radix-dapp-toolkit";
import { notify } from '../../utils/services/notification';
import { getAccessToken, logout } from "./auth";
import axios from "axios";
import { baseUrl, encryptedBaseUrl } from "../config/urls";
import CryptoJS from "crypto-js";
import History from "./GlobalNavigation/navigationHistory";


let hexMessage: string | null = null;
const RADIX_DEPOSIT_ADDRESS = process.env.REACT_APP_RADIX_DEPOSIT || "";


const getChallenge= async () => {
    return new Promise((resolve) => {
        setTimeout(() => resolve(hexMessage || ''), 0);
    });
};

const msgToSHA = async (msg: string) => {
    try {
        const hashedValue = CryptoJS.SHA256(msg).toString(CryptoJS.enc.Hex);
        return hashedValue;
    } catch (error) {
        console.error('ERROR IN MSGTOSHA ->', error);
        return null;
    }
}

export const radix_sign_message = async (): Promise<any> => {
    try {
        const store = currentStore();
        const rdt = store?.currentProvider?.radixDappToolkit;
        if (rdt?.walletApi) {
            rdt.disconnect();
            rdt.walletApi.setRequestData(
                DataRequestBuilder.accounts().atLeast(1)
            )
            const request1 = await rdt.walletApi.sendRequest();
            // console.log(request1,'request1----')
            const userAddress = request1?.value.accounts[0].address
            const res = await axios.get(
                `${baseUrl}/api/auth/get_message?publicKey=${userAddress}&encryption=true`
            );
            const message = res.data;
            hexMessage = await msgToSHA(message)


            rdt.walletApi.setRequestData(
                DataRequestBuilder.persona().withProof(),
                DataRequestBuilder.accounts().atLeast(1).withProof()
            )
            await rdt.walletApi.provideChallengeGenerator(getChallenge)
            const result = await rdt.walletApi.sendRequest();
            // console.log(result,'result----')

            const returnObject = {
                address: result?.value?.accounts[0]?.address,
                signed_message: JSON.stringify(result?.value?.proofs)
            }
            return returnObject;
        } else {
            logout();
        }

    } catch (error) {
        notify('Something went wrong', 'error');
        console.error(error, 'Error inside radix_sign_message')
    }

}
    ;

export const radix_sign_auth_message = async (): Promise<string | void> => {
    try {
        const store = currentStore();
        const rdt = store?.currentProvider?.radixDappToolkit;
        if (rdt?.walletApi) {
            rdt.walletApi.setRequestData(
                DataRequestBuilder.accounts().atLeast(1)
            )
            const request1 = await rdt.walletApi.sendRequest();
            const userAddress = request1?.value.accounts[0].address
            const messageRequested = await axios.get(
                `${encryptedBaseUrl}/api/message/${userAddress}`
            );
            const message = messageRequested?.data?.[0]?.message;
            hexMessage = await msgToSHA(message)
            // console.log(rdt,'rdt-1')

            rdt.walletApi.setRequestData(
                DataRequestBuilder.persona().withProof(),
                DataRequestBuilder.accounts().atLeast(1).withProof()
            )
            // console.log(rdt,'rdt-2')

            await rdt.walletApi.provideChallengeGenerator(getChallenge)
            // console.log(rdt,'rdt')
            const result = await rdt.walletApi.sendRequest();
            return JSON.stringify(result?.value?.proofs);
        } else {
            logout()
        }
    } catch (error) {
        notify('Something went wrong', 'error');
        console.error('Error inside radix_sign_auth_message', error)
    }
};

export const getXRDTokenBalance = async (): Promise<string | any> => {
    const store = currentStore();
    const rdt = store?.currentProvider?.radixDappToolkit;
    if (rdt?.walletApi) {
        try {
            const walletData = await rdt?.walletApi?.getWalletData();
            const response = await axios.post('https://radix-mainnet.rpc.grove.city/v1/326002fc/core/lts/state/account-fungible-resource-balance', {
                network: "mainnet",
                account_address: walletData?.accounts[0]?.address,
                resource_address: "resource_rdx1tknxxxxxxxxxradxrdxxxxxxxxx009923554798xxxxxxxxxradxrd"
            });
            return response?.data?.fungible_resource_balance?.amount || '0';
        } catch (error) {
            console.error('Error getting XRD balance:', error);
            return '0';
        }

    } else {
        logout();
    }
};

export const usdToXRD = async (amount: number) => {
    const response = await axios.get(
        `${baseUrl}/api/lighthouse/get_ticker?symbol=xrd`
    );
    const conversionRate = response?.data;
    const amountInXRD = (amount / conversionRate).toFixed(2);
    return amountInXRD;
}


export const initiateRadixPayment = async (amount: number,
    planID: string , setIsLoading: (isLoading:boolean) => void) => {

    try {
        const store = currentStore();
        const rdt = store?.currentProvider?.radixDappToolkit;
        if (rdt?.walletApi) {
            const walletData = await rdt?.walletApi?.getWalletData();
            const account_address = walletData?.accounts[0]?.address;
            const deposit_address = RADIX_DEPOSIT_ADDRESS;
            const amountInXRD = await usdToXRD(amount)
            const resource_address = 'resource_rdx1tknxxxxxxxxxradxrdxxxxxxxxx009923554798xxxxxxxxxradxrd'

            const manifest = `CALL_METHOD
    Address("${account_address}")
    "withdraw"
    Address("${resource_address}")
    Decimal("${amountInXRD}")
;
TAKE_FROM_WORKTOP
    Address("${resource_address}")
    Decimal("${amountInXRD}")
    Bucket("bucket1")
;
CALL_METHOD
    Address("${deposit_address}")
    "try_deposit_or_abort"
    Bucket("bucket1")
    Enum<0u8>()
;`

            const result = await rdt.walletApi.sendTransaction({
                transactionManifest: manifest,
                version: 1,
            });
            if (result?.value?.status === "CommittedSuccess") {
                const response = await axios.post(
                    `${baseUrl}/api/topup/purchase_plan_via_radix`,
                    {
                        subscriptionId: planID + '',
                        transactionHash: result?.value?.transactionIntentHash,
                        address: account_address,
                        amount: amountInXRD,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${getAccessToken()}`,
                        },
                        maxContentLength: 100000000,
                        maxBodyLength: 1000000000,
                    }
                );
                response && notify(
                    "Transaction Success: It can take a few minutes for the plan to get activated",
                    "success"
                );
                History.push('/dashboard');

            }
            if (result.isErr()) throw result.error;
            // console.log("free_token result: ", result.value);
        }

    } catch (error) {
        setIsLoading(false);

    }

}